import { useCallback } from 'react';

import { useScreenMessage } from '@gogame/screens';

import { loadDimesnions } from '../source/dimensions';

export const useLoadDimensions = () => {
  const { showErrorMessage } = useScreenMessage();
  return useCallback(() => {
    return loadDimesnions().catch(e => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
  }, [showErrorMessage]);
};
